import { render, staticRenderFns } from "./PasswordReset.vue?vue&type=template&id=b42b7c48&scoped=true"
import script from "./PasswordReset.vue?vue&type=script&lang=js"
export * from "./PasswordReset.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/authen.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/css/newLogin.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./PasswordReset.vue?vue&type=style&index=2&id=b42b7c48&prod&lang=css"
import style3 from "./PasswordReset.vue?vue&type=style&index=3&id=b42b7c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42b7c48",
  null
  
)

export default component.exports